// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpiredPage_container__31GsQ","links":"ExpiredPage_links__387tP","homeBtn":"ExpiredPage_homeBtn__37CR2","planBtn":"ExpiredPage_planBtn__7uIPw"};